module.exports = __webpack_public_path__ + "img/menu-home.d3861bea.png";